var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"add-btn",attrs:{"role":"button"}},[_c('i',{class:_vm.iconClass}),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }